import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteVisibilityReport } from '../../services/visibility-report/VisibilityReportService';
import { GET_VISIBILITY_REPORTS } from '../../query/visibility-report/keys';

export const useDeleteVisibilityReport = (projectId: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (reportId: number) => deleteVisibilityReport(reportId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [GET_VISIBILITY_REPORTS, projectId] });
    },
  });
};

/**
 * Kasowanie zaznaczonych. Backend nie ma endpointu zbiorczego, a i nie jest potrzebny — strona ma
 * najwyżej 100 wierszy, więc lecimy równolegle po pojedynczym DELETE i odświeżamy listę raz.
 */
export const useDeleteVisibilityReports = (projectId: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (reportIds: number[]) => {
      await Promise.all(reportIds.map((reportId) => deleteVisibilityReport(reportId)));
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [GET_VISIBILITY_REPORTS, projectId] });
    },
  });
};
